import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

const UPDATE_CUSTOMER = gql`mutation updateCustomer($id: String!, $payload: CustomerInput){
  updateCustomer(id: $id, input: $payload) {
    id
    document
    email
    first_name: firstName
    last_name: lastName
    createdIn
    updatedIn
  }
}`

const Customers = ({ children, ...props }) => {
  return (
    <MutationManager mutation={UPDATE_CUSTOMER}>
      {({ data, loading, updateFn }) => children({ updateFn, loading, ...props })}
    </MutationManager>
  )
}

Customers.propTypes = {
  children: PropTypes.any
}

export default Customers
